import _ from "lodash";

const FilterUrl = () => {
	let id;
	let addr = _.compact(_.split(window.location.href, "/"));

	_.filter(addr, (value) => {
		if (parseInt(value)) {
			id = +value;
		}
	});

	return id;
};

export default FilterUrl;
